import type { SetRequired } from 'type-fest';

import { routesWithNavbarItem } from '@routes/route-metadata';
import type { RouteMetadata } from '@routes/types';

export type NavigableRouteMetadata = SetRequired<RouteMetadata, 'navbar'>;
export const navigableRoutes = routesWithNavbarItem.filter(
  item => !('show' in item.navbar) || item.navbar.show,
);
export const navBarItems = navigableRoutes.map(item => item.navbar.title);
export type NavbarItemTitle = (typeof navBarItems)[number];
export const navigableRouteMetadata =
  navigableRoutes as NavigableRouteMetadata[];
